import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type RemoveDefaultTemplateSuccessModalProps = {
  open: boolean
  handleClose: VoidFunction
}

export function RemoveDefaultTemplateSuccessModal({
  open,
  handleClose
}: Readonly<RemoveDefaultTemplateSuccessModalProps>) {
  const { t } = useTranslation()

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="remove-default-template-success"
      data-testid="remove-default-template-success-modal"
    >
      <AcknowledgeModal
        result="positive"
        title={t('dialog.templates.removeDefault.success.title')}
        buttonText={t('button.close')}
        handleClose={handleClose}
        buttonTestId="remove-default-success-modal-btn"
      >
        {t('dialog.templates.removeDefault.success.description')}
      </AcknowledgeModal>
    </Modal>
  )
}
